import { useHistory } from 'react-router-dom';
import { UUID } from './UUID';
import { urlParams } from '../Utility/QueryString';
import { usePouchDBDataAsString } from '../Hooks/usePouchDBData';

export const CheckUUID = () => {
  const full_url = window.location.href;
  const params = new URLSearchParams(window.location.search);
  const history = useHistory();
  const { fetchUuid } = UUID();
  const split_name = params.get('splitName');
  const local_storage_uuid = usePouchDBDataAsString('uuid');
  const isCheck = () => {
    var flag = false;
    var localFlag = false;
    if (
      !params.has('uuid') ||
      (params.has('uuid') && !params.get('uuid')) ||
      (params.has('uuid') && params.get('uuid') === '""')
    ) {
      flag = true;
    }
    if (!local_storage_uuid) {
      localFlag = true;
    }
    if (flag && localFlag) {
      history.push('/404');
      return false;
    } else {
      const uuid = fetchUuid();
      window.history.pushState(
        {},
        '',
        '?uuid=' + uuid + '&splitName=' + split_name
      );
      return true;
    }
  };
  return { isCheck };
};
